import { isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import ENGLanguagePackContentType from "./ENGLanguagePackContentType";

/**
 * MovieContent.js
 * 
 * Created on Sep 28, 2013, 11:48:29 AM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class MovieContent extends Content {
    constructor(languagePack, contentID, movie, label) {
        isUndefined(contentID) ? contentID = null : null;
        isUndefined(movie) ? movie = null : null;
        isUndefined(label) ? label = null : null;
        super(MovieContent.NAME, MovieContent.TYPE, label, languagePack, contentID);

        this.setMovie(movie);
        this._videoControls = false;

        /**
         * The VideoPlayer is expected to signal "completion" of the video content a certain
         * number of milliseconds before the actual end of the content is reached.
         * This number defaults to zero, which is the default behaviour: don't signal the end
         * prematurely. However, this variable allows us to perform some actions a certain
         * number of milliseconds *before* the end of the video. In that sense, it is the
         * inverse of a Delay.
         */
        this._completionOffsetBeforeEndInMilliseconds = 0;
    }
    setMovie(value) {
        if (this.getMovie() !== value) {
            this.setLanguagePackContent(MovieContent.MOVIE_LABEL, ENGLanguagePackContentType.MOVIE, value);
        }
    }
    getMovie() {
        return this.getLanguagePackContent(MovieContent.MOVIE_LABEL, ENGLanguagePackContentType.MOVIE);
    }
    setVideoControls(value) {
        this._videoControls = value;
    }
    getVideoControls() {
        return this._videoControls;
    }
    /**
         * Set the number of milliseconds before the end of the video the player is
         * expected to signal completion of the video.
         */
    setCompletionOffsetBeforeEnd(value) {
        this._completionOffsetBeforeEndInMilliseconds = value;
    }
    /**
         * Get the number of milliseconds before the end of the video the player is
         * expected to signal completion of the video.
         */
    getCompletionOffsetBeforeEnd() {
        return this._completionOffsetBeforeEndInMilliseconds;
    }
    convertToObject() {
        return this.getObject(["videoControls", "completionOffsetBeforeEnd"]);
    }
}

MovieContent.NAME = "Movie";
MovieContent.TYPE = "engMovieContent";
MovieContent.MOVIE_LABEL = "movie";
MovieContent.VIDEO_CONTROLS = "videoControls";









